module.exports = __webpack_public_path__ + "static/img/1042_small.5df5ca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1042_small.png
// module id = LjGF
// module chunks = 1